export default "__VITE_ASSET__BDJoySnR__"